module.exports = __webpack_public_path__ + "static/media/new-generation.718fc987.jpg";